
<template>
    <section>
        <BCard no-body class="mb-0">

            <!-- Info -->
            <ContactSourcesListInfo :perPageOptions="perPageOptions" :perPage.sync="perPage">
                <div class="d-flex justify-content-end">               
                <!-- <BButton variant="primary" :to="{ name: 'teachers-add' }" v-if="ability.can('create', 'teacher')"> <span class="text-nowrap">{{$t('Add teacher')}}</span> </BButton> -->
                 <BButton variant="primary" @click="addModal.open()">Añadir forma de contacto</BButton>
              </div>
            </ContactSourcesListInfo>

            <!-- Table -->
            <BTable ref="refTable" :items="contactSources" :fields="tableColumns" responsive>
                <template #cell(action)="data">
                    <BButton variant="danger" size="sm" @click="deleteModal.open()">
                        <FeatherIcon icon="TrashIcon" size="16" />
                        <span class="align-middle ml-50">Eliminar</span>
                    </BButton>
                </template>
            </BTable>

            <!-- Pagination -->
            <ContactSourcesListPagination :pagination="pagination" :total="total" :perPage="perPage" :currentPage.sync="currentPage" />

            <!-- Modal: Añadir -->
            <Modal ref="addModal">
                <ContactSourcesAddForm />
            </Modal>
            
            <!-- Modal: Eliminar -->
             <Modal ref="deleteModal">
                <BRow class="p-2">
                    <p class="col-12 text-center">Eliminar forma de contacto</p>
                    <div class="d-flex col-12 justify-space-between mt-2">
                        <BButton variant="primary">Si</BButton>
                        <BButton variant="secondary" @click="deleteModal.close()">No</BButton>
                    </div>
                </BRow>
             </Modal>
        </BCard>
    </section>
</template>

<script>
import { BButton, BCard, BRow, BTable } from 'bootstrap-vue';
import ability from '@/libs/acl/ability'
import contactSourcesListQuery from './contactSourcesListQuery';
import ContactSourcesListPagination from './ContactSourcesListPagination.vue';
import ContactSourcesListInfo from './ContactSourcesListInfo.vue';
import { ref, watch } from '@vue/composition-api';
import Modal from '@/components/Modal.vue';
import ContactSourcesAddForm from './ContactSourcesAddForm.vue';

export default {
    components: {
        BCard, BTable, BRow, BButton, ContactSourcesListPagination, ContactSourcesListInfo, Modal, ContactSourcesAddForm
    },
    setup() {
        const { fetchData, contactSources, tableColumns, pagination, total, perPage, perPageOptions, currentPage, sortBy, isSortDirDesc, refTable } = contactSourcesListQuery()
        const addModal = ref(null)
        const deleteModal = ref(null)

        fetchData()

        watch([currentPage, perPage, sortBy, isSortDirDesc], () => {
            fetchData()
            refTable.value.refresh()
        })

        return {
            fetchData,
            addModal,
            deleteModal,
            contactSources,
            tableColumns,
            pagination,
            total,
            perPage,
            perPageOptions,
            ability,
            currentPage,
            refTable,
        }
    }
}
</script>